import DatePicker from "vue2-datepicker"
// Constants
import { STATUS_CODES } from "@/app/constants/constants"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"
import { numberFormatMixins } from "@/app/mixins/modules/number-format-mixins"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { imageUploadMixins } from "@/app/mixins/utils/image-upload-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import breedingManagementService from "@/app/services/main/breeder/breeding-management-service.js"

export default {
    name: "DamSireListComponent",
    components: {
        DatePicker
    },
    mixins: [
        toastMessageMixins,
        numberFormatMixins,
        tableMixins,
        imageUploadMixins,
        dateMixins
    ],
    data() {
        return {
            isAPILoading: false,
            breederNotes: "",
            isBreederAvailable: false,
            isDetailsUpdated: false,
            backButtonLabel: this.backButtonTitle,
            tableContent: {},

            // table
            theads: [
                {
                    name: "Dog Name",
                    searchLabel: "f_dogName",
                    sortLabel: "dogName",
                    hasSearch: true,
                    isDesc: false,
                    style: "min-width: 185px;"
                },
                {
                    name: "Breed",
                    searchLabel: "f_breedName",
                    sortLabel: "breedName",
                    hasSearch: true,
                    isDesc: false,
                    style: "min-width: 200px;"
                },
                {
                    name: "Gender",
                    hasGenderFilter: true,
                    searchLabel: "f_gender",
                    sortLabel: "gender",
                    isDesc: false,
                    style: "min-width: 180px;"
                },
                {
                    name: "Date of Birth",
                    hasDateOfBirthFilter: true,
                    searchLabel: "f_dateOfBirth",
                    sortLabel: "dateOfBirth",
                    isDesc: false,
                    style: null
                },
                // {
                //     name: "Type of Birth",
                //     searchLabel: "f_typeOfBirth",
                //     sortLabel: "typeOfBirth",
                //     hasTypeOfBirth: true,
                //     isDesc: false,
                //     style: null
                // },
                { name: null, searchLabel: null, sortLabel: null, isDesc: false, style: "width: 170px" },
            ],

            genderList: [{
                value: "dam",
                name: "Dam",
            },
            {
                value: "sire",
                name: "Sire",
            }],
            typeOfBirthList: [{
                value: "natural",
                name: "Natural",
            },
            {
                value: "c-section",
                name: "C-section",
            }],
            selectGender: '',
            selectTypeOfBirth: '',
            selectedDateOfBirth: '',
            limit: 10,
            // pagination
            page: 1,
            pageCount: 0,
            totalCount: 0,
            // sorting
            sortBy: '',
            desc: true,
            columnsFilter: {},
            breederId: this.$route.params.id,
            filterValues:{},

        }
    },
    watch: {
        selectGender() {
            this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc)
        },
        selectedDateOfBirth() {
            this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc)
        },
        selectTypeOfBirth() {
            this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc)
        },
    },

    created() {
        this.breederId = this.$route.params.id
        this.loadSavedFilters();
        this.getTableContent();
    },
    activated() {
		this.loadSavedFilters()
        this.getTableContent();
	},

    methods: {
        onDataFilter(filterBy, value) {
			if (filterBy) {
				this.page = 1;
				this.columnsFilter[filterBy] = value;
                this.filterValues[filterBy] = value;
				this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc);
			}
		},
        onColumnDataFilter(filterBy, event) {
			if (filterBy) {
				this.page = 1;
                this.columnsFilter[filterBy] = event.target.value;
                this.filterValues[filterBy] = event.target.value;
                this.delayTyping(() => {
					this.getTableContent(false, this.page, this.limit, this.sortBy, this.desc);
				});
			}
		},
        clearFilters() {
            const filters = this.$store.state.breederDamSireListFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0; 
            if (hasFilters) {
                this.$store.dispatch('resetBreederDamSireListFilters');
            }
        },
        saveAllFilters() {
            const filters = {};
                // Collect all the column filter values
                this.theads.forEach(th => {
                    if (th.hasDateOfBirthFilter) {
                        filters[th.searchLabel] = this.selectedDateOfBirth;
                    } else if (th.hasGenderFilter) {
                        filters[th.searchLabel] = this.selectGender;
                    }  else if (th.hasTypeOfBirth) {
                        filters[th.searchLabel] = this.selectTypeOfBirth;
                    }else {
                        const searchInput = this.columnsFilter[`${th.searchLabel}`];
                        if (searchInput) {
                            filters[th.searchLabel] = searchInput;
                        }
                    }
                });

                // Add pagination details to filters
                filters.page = this.page; // current page
                filters.limit = this.limit; // items per page
                filters.sortBy = this.sortBy
                filters.isDesc = this.desc

                // Dispatch all filters, including pagination, to Vuex store
                Object.keys(filters).forEach(label => {
                    this.$store.dispatch('applyBreederDamSireListFilters', { label, value: filters[label] });
                });
          },  
          loadSavedFilters() {
            const filters = this.$store.state.breederDamSireListFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0;
            if (hasFilters) {
                this.page = this.$store.getters.getBreederDamSireListFilters('page') || 1;
				this.limit = this.$store.getters.getBreederDamSireListFilters('limit') || 10; 
				this.sortBy = this.$store.getters.getBreederDamSireListFilters('sortBy') || '';
				this.desc = this.$store.getters.getBreederDamSireListFilters('isDesc'); 
        
                // You can access the saved filter values from the store like this:
                this.theads.forEach(th => {
                    if(this.sortBy === th.sortLabel) {
						th.isDesc =  this.desc
					}
                    const savedFilter = this.$store.getters.getBreederDamSireListFilters(th.searchLabel);
                    if (savedFilter) {
                        this.columnsFilter[th.searchLabel] = savedFilter;
                        if (th.hasDateOfBirthFilter) {
                            this.selectedDateOfBirth= savedFilter
                        } else if (th.hasGenderFilter) {
                            this.selectGender = savedFilter
                        } else if(th.hasTypeOfBirth) {
                            this.selectTypeOfBirth = savedFilter
                        } else {
                            this.filterValues[th.searchLabel] = savedFilter
                        }
                    }

                }); 
                this.clearFilters()
            }
        },  
        handleClick(damSire) {
           this.saveAllFilters()
           const savedTabId = localStorage.getItem('selectedTab');
           if (!savedTabId) {
               localStorage.setItem('selectedTab', 'damSireList');
           } 
           this.$router.push(`/breeder-management/dam-sire/${this.breederId}/${damSire.id}`);
        },
        getTableContent(
            fromFilter = false,
            page = this.page,
            limit = this.limit,
            sortBy = this.sortBy,
            desc = this.desc,
            
        ) {
            page = fromFilter ? 1 : this.page
            this.getDamSireList({ page, limit, sortBy, desc })
        },
        getDamSireList(queryParams) {

            // search filters
            this.isAPILoading = true

            queryParams["f_breederSysId"] = this.$route.params.id

            if (this.columnsFilter) {
                if (this.columnsFilter.f_dogName) {
                    queryParams["f_dogName"] = this.columnsFilter.f_dogName
                }
                if (this.columnsFilter.f_breedName) {
                    queryParams["f_breedName"] = this.columnsFilter.f_breedName
                }
            }

            if (this.selectGender) {
                queryParams["f_gender"] = this.selectGender;
            }

            if (this.selectTypeOfBirth) {
                queryParams["f_typeOfBirth"] = this.selectTypeOfBirth;
            }

            if (this.selectedDateOfBirth) {
                queryParams["f_dateOfBirth"] = this.formatDateWithoutConversion(this.selectedDateOfBirth, "yyyy-MM-dd HH:mm");
            }
            
           
            breedingManagementService.getBreederDamAndSireList(queryParams)
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.tableContent = {
                            tableData: res.data.data,
                            paginationData: res.data.pagination,
                        }
                    } else {
                        this.showAPIErrorToast(res)
                    }
                })
                .catch((err) => {
                    this.showGenericErrorToast()
                    
                })
                .finally(() => {
                    this.isAPILoading = false
                })
        },

        showDamSireDetails(damSireId) {
            if (!damSireId) {
                return;
            }
            this.$router.push(`${BREEDER_ROUTES.EDIT_DAM_SIRE}?id=${damSireId}`);
        },
        capitalizeFirstLetter(word) {
            if (typeof word !== 'string' || word.length === 0) {
                return word;
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        },

    },
}
